/**
 * 检测订单
 */
import React from 'react';
import { Row, Col, Button, Icon, Tooltip, DatePicker, Input, Select } from 'antd';
import PageLayout from '../../ui/PageLayout';
//车辆详情信息和审核
//import VehicleAuditDetail from './VehicleAuditDetail';
//加载中遮罩
import Loading from '../../ui/Loading';
import DictSelect from '../../ui/DictSelect';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import { global_data } from '../../ui/auth'


class VehicleCheckIndex extends React.Component {

    columns = [{
        title: '订单编号',
        dataIndex: 'id',
        width: '5%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '5%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '3%',
    }, {
        title: '联系人',
        dataIndex: 'contactPerson',
        width: '3%',
    }, {
        title: '电话',
        dataIndex: 'telephone',
        width: '3%',
    }, {
        title: '套餐类型',
        dataIndex: 'type',
        width: '4%',
        render: (text, record, index) => (
            text === 1 || text === "1" ? "事故排查检测" :  
            text === 2 || text === "2" ? "重要部件检测" : 
            text === 3 || text === "3" ? "全车检测" : 
            text === 4 || text === "4" ? "豪车检测" : "-"
        )
    },{
        title: '订单状态',
        dataIndex: 'state',
        width: '3%',
        render: (text, record, index) => (
            text === -1 || text === "-1" ? "已取消" :  
            text === 0 || text === "0" ? "待付款" : 
            text === 1 || text === "1" ? "待检测" : 
            text === 2 || text === "2" ? "已完成" : 
            text === 3 || text === "3" ? "检测失败" : "-"
        )
    },{
        title: '支付类型',
        dataIndex: 'payType',
        width: '3%',
        render: (text, record, index) => (
            text === 1 || text === "1" ? "公司支付" :  
            text === 2 || text === "2" ? "微信支付" : "-"
        )
    },{
        title: '创建人',
        dataIndex: 'name',
        width: '4%',
    },{
        title: '公司名称',
        dataIndex: 'memberName',
        width: '6%',
    },{
        title: '创建时间',
        dataIndex: 'createTime',
        width: '4%',
    },{
        title: '查博士订单号',
        dataIndex: 'orderNo',
        width: '6%',
    },{
        title: '操作',
        width: '3%',
        render: (text, record, index) => (
            <div>
                {
                    global_data.authCode.includes("CHECK_ORDER_CANCEL")&&(record.state === 0||record.state === 1) ?
                    <Tooltip title="取消订单">
                        <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} /> 
                    </Tooltip>
                    :''
                }
            </div>
        )
    }];
    //页面参数
    state = {
        visible: false,
        loadData: '',
        queryData: {},
        loadingVisible: false
    };

    detail = (info, e) => {
        messager.confirm("是否取消该申请单？", () => {
            http.get({
                url: '/check/cancel',
                data: { id: info.id },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("取消成功！");
                },
                error: (res) => {
                    messager.notify(res);
                }
            });
        });
    }

    // 导出
   download = () => {
    let queryData = this.state.queryData;
    if (queryData.startDateStr == null || queryData.endDateStr === "") {
        messager.notify("导出时需选择时间段！", null, "warning");
        return;
    }
    this.setState({ loadingVisible: true });
    let fileName = queryData.startDateStr + "~" + queryData.endDateStr + "-查博士检测订单.xlsx";
    http.download({
      url: '/check/excel',
      data: queryData,
      fileName: fileName,
      success: (res) => {
        this.setState({ loadingVisible: false });
      }
  });
  messager.notify("只会根据查询的时间段导出已经打印的数据！");
  }

    //车架号
    vinInputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.vin = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }
    //车牌号
    plateNoInputSearch= (value) => {
        let queryData = this.state.queryData;
        queryData.plateNo = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }
    //创建人
    userInputSearch= (value) => {
        let queryData = this.state.queryData;
        queryData.userName = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }
    //时间区间
    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDateStr = dateStrings[0];
        queryData.endDateStr = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }
    //套餐类型
    onSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.typeCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }
    //状态
    selectChange = (res) => {
        let queryData = this.state.queryData;
        queryData.state = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <Input.Search
                                    placeholder="车架号"
                                    onSearch={this.vinInputSearch}
                                    enterButton
                                    style={{ width: '150px',margin: '0 10px'  }} />
                                <Input.Search
                                    placeholder="车牌号"
                                    onSearch={this.plateNoInputSearch}
                                    enterButton
                                    style={{ width: '150px'}} />
                                <Input.Search
                                    placeholder="创建人"
                                    onSearch={this.userInputSearch}
                                    enterButton
                                    style={{ width: '150px',margin: '0 10px'  }} />
                                <DictSelect category="CHECK_ORDER_TYPE" allowClear={true} onChange={this.onSelect} style={{ width: '200px' }} />
                                <Select onChange={this.selectChange} allowClear={true} style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option key={"0"}>待付款</Select.Option>
                                    <Select.Option key={"1"}>待检测</Select.Option>
                                    <Select.Option key={"2"}>已完成</Select.Option>
                                    <Select.Option key={"3"}>检测失败</Select.Option>
                                    <Select.Option key={"-1"}>已取消</Select.Option>
                                </Select>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.download.bind(this)}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/check/getOrderPage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中..."
                />
            </div>
        )
    }
}

export default VehicleCheckIndex;